<template>
  <div class="search-ads-campaigns-stats-chart">
    <header class="search-ads-campaigns-stats-chart__header">
      <h3 class="search-ads-campaigns-stats-chart__title">
        {{ $t('ADVERTISEMENT.CAMPAIGNS.SEARCH_ADS_‌CHART_TITLE') }}
      </h3>
    </header>
    <div class="search-ads-campaigns-stats-chart__content">
      <div class="search-ads-campaigns-stats-chart__legends">
        <SearchAdsCampaignsStatsChartLegend
          :title="$t('ADVERTISEMENT.CAMPAIGNS.TOTAL_IMPRESSIONS_COUNT')"
          :value="totalImpressionCountFormatted"
          class="search-ads-campaigns-stats-chart__legend"
          :color="seriesColors[0]"
          :is-active="chartsVisibility[0]"
          @click="handleClickLegend(0)"
        />
        <SearchAdsCampaignsStatsChartLegend
          :title="$t('ADVERTISEMENT.CAMPAIGNS.CONVERSION_RATE')"
          :value="averageConversionRateFixed"
          class="search-ads-campaigns-stats-chart__legend"
          :color="seriesColors[1]"
          :is-active="chartsVisibility[1]"
          @click="handleClickLegend(1)"
        />
      </div>
      <SearchAdsCampaignsStatsChartContent
        :impression-counts="impressionCounts"
        :conversion-rates="conversionRates"
        :dates="dates"
        :charts-visibility="chartsVisibility"
        :series-colors="seriesColors"
      />
    </div>
  </div>
</template>

<script>
import Color from '@/utils/color';
import { format } from '@/utils/number';
import SearchAdsCampaignsStatsChartLegend from './SearchAdsCampaignsStatsChartLegend';
import SearchAdsCampaignsStatsChartContent from './SearchAdsCampaignsStatsChartContent';

const SERIES_COUNT = 2;

export default {
  name: 'SearchAdsCampaignsStatsChart',
  components: {
    SearchAdsCampaignsStatsChartLegend,
    SearchAdsCampaignsStatsChartContent,
  },
  props: {
    impressionCounts: {
      type: Array,
      required: true,
    },
    conversionRates: {
      type: Array,
      required: true,
    },
    dates: {
      type: Array,
      required: true,
    },
    averageConversionRate: {
      type: Number,
      required: true,
    },
    totalImpressionCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    const chartsVisibility = {};
    for (let i = 0; i < SERIES_COUNT; i++) {
      chartsVisibility[i] = true;
    }

    return {
      chartsVisibility,
    };
  },
  computed: {
    seriesColors() {
      return Color.get(SERIES_COUNT).byStep(2, 6);
    },
    averageConversionRateFixed() {
      return this.averageConversionRate.toFixed(2);
    },
    totalImpressionCountFormatted() {
      return format(this.totalImpressionCount);
    },
  },
  methods: {
    handleClickLegend(index) {
      this.chartsVisibility[index] = !this.chartsVisibility[index];
    },
  },
};
</script>

<style lang="scss">
.search-ads-campaigns-stats-chart {
  height: 100%;
  border: 1px solid $light-gray;
  border-radius: $lb-border-radius * 5;
  padding: $global-padding;
  background-color: #fff;

  &__header {
    padding-bottom: $global-padding * 1.5;
    border-bottom: 1px solid $light-gray;
  }

  &__title {
    font-size: rem-calc(17px);
  }

  &__legends {
    padding-top: $global-padding;
    padding-bottom: $global-padding / 2;
    display: flex;
  }

  &__legend {
    &:not(:first-child) {
      margin-left: calc($global-margin / 2);
    }
    @include rtl() {
      margin-left: 0;

      &:not(:last-child) {
        margin-left: calc($global-margin / 2);
      }
    }
  }
}
</style>
